import {createToolbarButton} from '../../components/toolbar-button/toolbar-button-factory';
import {translate} from 'shared/services/I18nService';

const DEFAULT_BUTTON_CLASS = 'uscope-manual-sync-button';
const ACTIVE_BUTTON_CLASS = 'uscope-manual-sync-active';
const BUTTON_HOVER_TEXT = 'toolbar-button-hover-text';

export function createButton (eventChannel, onClick) {
  const $t = translate.scope('uScope.extensions.manual-sync');
  const button = createToolbarButton({
    className: DEFAULT_BUTTON_CLASS,

    title: $t(BUTTON_HOVER_TEXT),

    onClick
  });

  const enableButton = () => {
    button.disabled = false;
  };
  const disableButton = () => {
    button.disabled = true;
  };

  const activateButton = () => {
    button.classList.add(ACTIVE_BUTTON_CLASS);
  };
  const deactivateButton = () => {
    button.classList.remove(ACTIVE_BUTTON_CLASS);
  };

  eventChannel.on('manual-sync:enabled-on', enableButton);
  eventChannel.on('manual-sync:enabled-off', disableButton);
  eventChannel.on('manual-sync:active-on', activateButton);
  eventChannel.on('manual-sync:active-off', deactivateButton);

  return button;
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/manual-sync/toolbar-button-helper.js